<template>
  <div class="page-con">
    <div class="page-con-header clearfix">
      <Button type="primary" @click="batchDownload" icon="md-download"
              v-if="isHavePermission('clientContract:batchDownload')"
              style="border-radius: 5px;">合同批量下载
      </Button>
      <vxe-button icon="vxe-icon--refresh" @click="refresh"
                  :style="isHavePermission('clientContract:batchDownload') ? 'margin-left: 10px' :''">刷新
      </vxe-button>
      <div class="search-filter">
        <Poptip placement="bottom-end" width="680" v-model="searchVisible">
          <em>
            <Icon type="ios-search-outline"/>
            搜索
          </em>
          <div class="search-box" slot="content">
            <vxe-form :data="searchFormData" title-align="left">
              <vxe-form-item
                  title="搜索"
                  field="receiveNum"
                  span="24"
                  :prefix="{ icon: 'fa fa-address-card-o' }"
              ></vxe-form-item>
              <vxe-form-item title="合同编号" field="contractNum" span="12">
                <template v-slot>
                  <vxe-input
                      v-model="searchFormData.contractNum"
                      placeholder="输入合同编号"
                  ></vxe-input>
                </template>
              </vxe-form-item>
              <vxe-form-item title="合同名称" field="contractName" span="12">
                <template v-slot>
                  <vxe-input
                      v-model="searchFormData.contractName"
                      placeholder="输入合同名称"
                  ></vxe-input>
                </template>
              </vxe-form-item>
              <vxe-form-item title="合同类型" field="contractType" span="12">
                <template v-slot>
                  <vxe-select
                      v-model="searchFormData.contractType"
                      :options="valueType"
                      placeholder="全部"
                  ></vxe-select>
                </template>
              </vxe-form-item>
              <vxe-form-item title="发起方" field="firstPartyName" span="12">
                <template v-slot>
                  <Select
                      v-model="searchFirstPartyName"
                      multiple
                      filterable
                      :default-label="[]"
                      :loading="searchLoading"
                      :max-tag-count="1"
                      :max-tag-placeholder="maxTagPlaceholder"
                      @on-set-default-options="(file) => setDefaultOptions(file, 'firstPartyNameOptions')"
                      placeholder="输入托运人"
                  >
                    <Option
                        v-for="option in firstPartyNameOptions"
                        :value="option.text"
                        :key="option.text"
                    >{{ option.text }}
                    </Option>
                  </Select>
                </template>
              </vxe-form-item>
              <vxe-form-item title="签约方" field="secondPartyName" span="12">
                <template v-slot>
                  <Select
                      v-model="searchSecondPartyName"
                      multiple
                      filterable
                      :default-label="[]"
                      :loading="searchLoading"
                      :max-tag-count="1"
                      :max-tag-placeholder="maxTagPlaceholder"
                      @on-set-default-options="(file) => setDefaultOptions(file, 'secondPartyNameOptions')"
                      placeholder="输入托运人"
                  >
                    <Option
                        v-for="option in secondPartyNameOptions"
                        :value="option.text"
                        :key="option.text"
                    >{{ option.text }}
                    </Option>
                  </Select>
                </template>
              </vxe-form-item>
              <vxe-form-item title="手机号" field="secondPartyPhone" span="12">
                <template v-slot>
                  <vxe-input
                      v-model="searchFormData.secondPartyPhone"
                      placeholder="输入手机号"
                  ></vxe-input>
                </template>
              </vxe-form-item>
              <vxe-form-item title="签约日期" field="secondPartyTime" span="12">
                <template v-slot>
                  <vxe-select
                      v-model="searchFormData.secondPartyTime"
                      :options="timeOptions"
                      placeholder="选择时间"
                  ></vxe-select>
                </template>
              </vxe-form-item>
              <vxe-form-item title="车船号" field="carShipNum" span="12">
                <template v-slot>
                  <vxe-input
                      v-model="searchFormData.carShipNum"
                      placeholder="输入车船号"
                  ></vxe-input>
                </template>
              </vxe-form-item>
              <vxe-form-item title="货名" field="goodsName" span="12">
                <template v-slot>
                  <vxe-input
                      v-model="searchFormData.goodsName"
                      placeholder="输入货名"
                  ></vxe-input>
                </template>
              </vxe-form-item>
              <vxe-form-item title="起运日期" field="goodsBeginDate" span="12">
                <template v-slot>
                  <vxe-select
                      v-model="searchFormData.goodsBeginDate"
                      :options="timeOptions"
                      placeholder="选择时间"
                  ></vxe-select>
                </template>
              </vxe-form-item>
              <vxe-form-item title="业务员" field="salesMan" span="12">
                <template v-slot>
                  <Select
                      v-model="searchSalesMan"
                      multiple
                      filterable
                      :default-label="[]"
                      :loading="searchLoading"
                      :max-tag-count="1"
                      :max-tag-placeholder="maxTagPlaceholder"
                      @on-set-default-options="(file) => setDefaultOptions(file, 'salesManOptions')"
                      placeholder="输入托运人"
                  >
                    <Option v-for="option in salesManOptions" :value="option.text" :key="option.text">{{ option.text }}
                    </Option>
                  </Select>
                </template>
              </vxe-form-item>
              <vxe-form-item title="创建人" field="createUser" span="12">
                <template v-slot>
                  <Select
                      v-model="searchCreateUser"
                      multiple
                      clearable
                      filterable
                      :default-label="[]"
                      :loading="searchLoading"
                      :max-tag-count="1"
                      :max-tag-placeholder="maxTagPlaceholder"
                      @on-set-default-options="(file) =>setDefaultOptions(file,'createUserOptions')"
                      placeholder="输入创建人"
                  >
                    <Option v-for="option in createUserOptions" :value="option.text" :key="option.text">{{ option.text
                      }}
                    </Option>
                  </Select>
                </template>
              </vxe-form-item>
              <vxe-form-item title="创建时间" field="createTime" span="12">
                <template v-slot>
                  <vxe-select
                      v-model="searchFormData.createTime"
                      :options="timeOptions"
                      placeholder="创建时间"
                  ></vxe-select>
                </template>
              </vxe-form-item>
              <vxe-form-item align="right" span="24">
                <template v-slot>
                  <Button status="primary" icon="ios-search" @click="getSearchListKey" style="border-radius: 5px">搜索
                  </Button>
                  <Button @click="reset" style="margin-left: 10px; border-radius: 5px">重置
                  </Button>
                </template>
              </vxe-form-item>
            </vxe-form>
          </div>
        </Poptip>
        <div class="search-filter">
          <vxe-modal
              class="timeModal"
              v-model="open"
              width="460"
              height="400"
              :show-footer="false"
              :showHeader="false"
          >
            <template v-slot>
              <DatePicker
                  :open="open"
                  confirm
                  type="daterange"
                  :split-panels="true"
                  placeholder
                  style="width: 432px"
                  @on-change="handleChange"
                  @on-clear="handleClear"
                  @on-ok="handleOk"
              >
                <span class="date-slot"></span>
              </DatePicker>
            </template>
          </vxe-modal>
        </div>
      </div>
    </div>
    <div class="list-box common-shadow clearfix">
      <vxe-table
          ref="xTable"
          class="table-style"
          highlight-hover-row
          show-footer
          stripe
          align="center"
          border="none"
          show-overflow
          max-height="740"
          :loading="loading"
          :data="tableData"
          :remote-filter="true"
          @filter-change="filterChangeMethod"
          @checkbox-all="selectAllEvent"
          @checkbox-change="selectChangeEvent"
      >
        <vxe-table-column type="checkbox" align="center" width="50"></vxe-table-column>
        <vxe-table-column title="操作" width="90">
          <template slot-scope="{ row }">
            <Dropdown trigger="click" style="margin-left: 10px; cursor: pointer" transfer
                      v-if="isHavePermission('clientContract:download')">
              <icon type="text" custom="iconfont icon-gengduo" size="12px"></icon>
              <DropdownMenu slot="list" style="left: 70px">
                <div style="display: flex; flex-direction: column">
                  <Button class="button-gengduo" v-if="row.state === 2 && row.secondPartyType === 1"
                          @click="getContractFadadaDetail(row)">签署
                  </Button>
                  <Button class="button-gengduo" v-if="isHavePermission('clientContract:download')"
                          @click="downloadContract(row)">下载
                  </Button>
                </div>
              </DropdownMenu>
            </Dropdown>
          </template>
        </vxe-table-column>
        <vxe-table-column field="contractNum" title="合同编号" width="150">
          <template slot-scope="{ row }">
            <a v-if="isHavePermission('clientContract:view')" @click="viewContract(row)">{{ row.contractNum}}</a>
            <span v-else>{{ row.contractNum}}</span>
          </template>
        </vxe-table-column>
        <vxe-table-column field="contractName" title="合同名称" width="120"></vxe-table-column>
        <vxe-table-column field="state" title="合同状态"
                          :filters="[{label: '待甲方签署', value: 1}, {label: '待乙方签署', value: 2}, {label: '待平台签署', value: 6},{label: '已签署', value: 3}, {label: '已拒绝', value: 4},{label: '已撤回', value: 5}]"
                          :filter-multiple="false" width="100">
          <template slot-scope="{ row }">
            <span :style="stateColor(row)">{{ state(row) }}</span>
          </template>
        </vxe-table-column>
        <vxe-table-column field="contractType" title="合同类型" width="150">
          <template slot-scope="{ row }">
            <span>{{ elecontractType(row.contractType) }}</span>
          </template>
        </vxe-table-column>
        <vxe-table-column field="firstPartyName" title="发起方" width="200">
          <template slot-scope="{ row }">
            <span>{{ row.firstPartyName }}</span>
          </template>
        </vxe-table-column>
        <vxe-table-column field="secondPartyName" title="签约方" width="200"></vxe-table-column>
        <vxe-table-column field="secondPartyPhone" title="手机号" width="150"></vxe-table-column>
        <vxe-table-column field="secondPartyTime" title="签约日期" width="150">
          <template slot-scope="{ row }">
            <span>{{ row.secondPartyTime | timeFormatDate}}</span>
          </template>
        </vxe-table-column>
        <vxe-table-column field="carShipNum" title="车船号" width="100"></vxe-table-column>
        <vxe-table-column field="goodsName" title="货名" width="100"></vxe-table-column>
        <vxe-table-column field="goodsBeginDate" title="起运日期" width="150">
          <template slot-scope="{ row }">
            <span>{{ row.goodsBeginDate | timeFormatDate}}</span>
          </template>
        </vxe-table-column>
        <vxe-table-column field="goodsBeginPlace" title="起运地" width="150"></vxe-table-column>
        <vxe-table-column field="goodsEndPlace" title="到达地" width="150"></vxe-table-column>
        <vxe-table-column field="salesMan" title="业务员" width="200"></vxe-table-column>
        <vxe-table-column field="createUser" title="创建人" width="150"></vxe-table-column>
        <vxe-table-column field="createTime" title="创建时间" width="150">
          <template slot-scope="{ row }">
            <span style="color: #a7adad">{{ row.createTime | timeFormatDate}}</span>
          </template>
        </vxe-table-column>
      </vxe-table>
      <vxe-pager
          background
          size="small"
          :current-page.sync="page.currentPage"
          :page-size.sync="page.pageSize"
          :total="page.totalResult"
          @page-change="changePage"
      ></vxe-pager>
    </div>
    <vxe-modal v-model="detailModal" title="合同详情" width="1000" height="900" position="center"
               resize>
      <contract-detail ref="detailModal" @close="closeDetail"></contract-detail>
    </vxe-modal>
  </div>
</template>

<script>
  import $api from "@/apiProvider";
  import $C from "@/consts";
  import {SEARCH_TIME} from "@/filters/time";
  import moment from "moment";
  import getAuthOrization from "@/mixin/getAuthOrization";
  import {blobToJson, getBlob, hideLoading, isEmpty, postBlob, saveBlob, showLoading,} from "@/utils/util";
  import ContractDetail from "@/views/contracts/contractDetail";

  moment.locale("zh-CN");

  export default {
    name: "EleContract",
    components: {ContractDetail},
    mixins: [getAuthOrization],
    data() {
      return {
        searchLoading: false,
        searchVisible: false,
        open: false,
        timeOptions: SEARCH_TIME.options,
        loading: false,
        modalTitle: "",
        tableData: [],
        searchFormData: {
          contractNum: null,
          contractName: null,
          contractType: null,
          secondPartyPhone: null,
          secondPartyTime: null,
          carShipNum: null,
          goodsName: null,
          goodsBeginDate: null,
          createTime: null,
          state: null
        },
        page: {
          currentPage: 1,
          pageSize: 10,
          totalResult: 100,
        },
        isShowModal: false,
        valueType: [],
        detailModal: false,
        searchFirstPartyName: [],
        firstPartyNameOptions: [],
        searchSecondPartyName: [],
        secondPartyNameOptions: [],
        searchSalesMan: [],
        salesManOptions: [],
        searchCreateUser: [],
        createUserOptions: [],
        paramsObj: {
          page: 1,
          rows: 10,
        },
        records: []
      };
    },
    watch: {
      "searchFormData.secondPartyTime": {
        deep: true,
        immediate: true,
        handler: function (val, oldVal) {
          this.openRangeDate("secondPartyTime");
        },
      },
      "searchFormData.goodsBeginDate": {
        deep: true,
        immediate: true,
        handler: function (val, oldVal) {
          this.openRangeDate("goodsBeginDate");
        },
      },
      "searchFormData.createTime": {
        deep: true,
        immediate: true,
        handler: function (val, oldVal) {
          this.openRangeDate("createTime");
        },
      },
    },
    mounted() {
      this.getList('', 'firstPartyNameOptions', 'eleContract', 'queryContractFadadaKeyword', 1);
      this.getList('', 'secondPartyNameOptions', 'eleContract', 'queryContractFadadaKeyword', 2);
      this.getList('', 'salesManOptions', 'eleContract', 'queryContractFadadaKeyword', 3);
      this.getList('', 'createUserOptions', 'eleContract', 'queryContractFadadaKeyword', 4);

      this.getDictByCode(41400, 'valueType');
      this.getContractFadadaByClientList(this.paramsObj);
    },
    methods: {
      async getContractFadadaDetail(row) {
        showLoading();
        let res = await $api.eleContract.post("getContractFadadaDetail", {
          id: row.id,
        });
        hideLoading();
        if (res.status === 1) {
          window.open(res.data.fadadaSignUrl);
        } else {
          this.$XModal.alert({
            message: res.message ? res.message : "接口异常",
            status: "error",
          });
        }
      },
      state(row) {
        let state = row.state;
        let secondPartyType = row.secondPartyType;
        if (state != null) {
          if (state === 1) {
            return "待甲方签署";
          }
          if (state === 2) {
            if (secondPartyType === 1) {
              return "待平台签署";
            } else {
              return "待乙方签署";
            }
          }
          if (state === 3) {
            return "已签署";
          }
          if (state === 4) {
            return "已拒绝";
          }
          if (state === 5) {
            return "已撤回";
          }
        }
      },
      async batchDownload() {
        let records = this.records;
        if (records.length === 0) {
          this.$XModal.alert({
            message: '请选择至少一条合同信息',
            status: "error",
          });
          return
        }
        let idList = [];
        records.map(i => {
          idList.push(i.id);
        })
        showLoading();
        let res = postBlob("/api/order/electricContract/downAttachFilesFadadaFile", {
          ids: idList
        });
        hideLoading();
        await saveBlob(".zip", res.data)
      },
      selectChangeEvent({checked, row}) {
        if (checked) {
          this.records.push(row);
        } else {
          let key = this.records.indexOf(row);
          this.records.splice(key, 1);
        }
      },
      selectAllEvent({checked, records}) {
        if (checked) {
          this.records = records;
        } else {
          this.records = [];
        }
      },
      stateColor(row) {
        if (row.state === 2 && row.secondPartyType === 1) {
          return 'color:red';
        }
      },
      closeDetail() {
        this.detailModal = false;
        this.refresh();
      },
      elecontractType(val) {
        let label = '';
        this.valueType.map(i => {
          if (val === i.value) {
            label = i.label;
          }
        })
        return label;
      },
      async getDictByCode(code, key) {
        let res = await $api.dict.get("searchDic", {
          parentcode: code
        });
        if (res.status === 1) {
          let arr = [];
          let data = res.data;
          data.map(i => {
            arr.push({
              label: i.dictText,
              value: i.dictCode,
            })
          })
          this[key] = arr;
        } else {
          this.$XModal.message(res.message);
        }
      },
      filterChangeMethod({values}) {
        this.page.currentPage = 1;
        if (values.length > 0) {
          if (values[0] === 2) {
            this.searchFormData.state = 2;
            this.searchFormData.secondPartyTypes = [2, 3];
          } else if (values[0] === 6) {
            this.searchFormData.state = 2;
            this.searchFormData.secondPartyTypes = [1];
          } else {
            this.searchFormData.state = values[0];
          }
        } else {
          this.searchFormData.state = null;
          this.searchFormData.secondPartyTypes = null;
        }
        this.getSearchListKey()
      },
      async getCompSignUrl(id) {
        showLoading();
        let res = await $api.eleContract.post("getCompSignUrl", {
          id: id,
          returnUrl: process.env.VUE_APP_LOGIN + '/agreement/eleContract'
        });
        hideLoading();
        if (res.status === 1) {
          window.location.href = res.data;
        } else {
          this.$XModal.alert({
            message: res.message ? res.message : "接口异常",
            status: "error",
          });
        }
      },
      downloadContract(row) {
        if (row.downloadUrl) {
          window.open(row.downloadUrl);
        } else {
          this.downLoad(row.docUrl);
        }
      },
      async downLoad(url) {
        let name = url.substring(url.lastIndexOf("/") + 1)
        let responsePromise = await fetch(url)
        let blob = await responsePromise.blob()
        let objectURL = window.URL.createObjectURL(blob)
        let a = document.createElement('a')
        a.href = objectURL
        a.download = name
        a.click()
        a.remove()
      },
      viewContract(row) {
        this.detailModal = true;
        this.$refs.detailModal.init(row, 'kh');
      },
      reset() {
        this.searchFormData = {
          contractNum: null,
          contractName: null,
          contractType: null,
          secondPartyPhone: null,
          secondPartyTime: null,
          carShipNum: null,
          goodsName: null,
          goodsBeginDate: null,
          createTime: null,
          state: null
        };
        this.searchFirstPartyName = [];
        this.searchSecondPartyName = [];
        this.searchSalesMan = [];
        this.searchCreateUser = [];
      },
      openRangeDate(field) {
        if (this.searchFormData[field] === 1) {
          this.rangeTime = field;
          this.open = true;
        } else {
          this.open = false;
        }
      },
      handleChange(date) {
        this.timeVal = date;
        // this.timeVal = date.map( v => moment(v).valueOf());
        console.log(this.timeVal);
      },
      handleClear() {
      },
      handleOk() {
        this.searchFormData[this.rangeTime] = this.timeVal;
        this.rangeTime = false;
        let that = this;
        setTimeout(() => {
          that.searchVisible = true;
        }, 100);
      },
      maxTagPlaceholder(num) {
        return "更多+ " + num;
      },
      remoteMethod(query, options, url, path, columnType) {
        if (query !== "") {
          this.searchLoading = true;
          this.getList(query, options, url, path, columnType);
        } else {
          this[options] = [];
        }
      },
      async getList(query, options, url, path, columnType) {
        let params = {
          columnType: columnType,
          moduleType: 5
        };

        if (!isEmpty(query)) {
          params.keyword = query;
        }
        if (isEmpty(this[options])) {
          this.searchLoading = true;
        }
        let res = await $api[url].post(path, params);
        this.searchLoading = false;
        if (res.status === 1) {
          this[options] = res.data;
        }
      },
      setDefaultOptions(options, option) {
        this[option] = options;
      },
      refresh() {
        this.getSearchListKey();
      },
      async getContractFadadaByClientList(obj) {
        this.loading = true;
        let res = await $api.eleContract.request("getContractFadadaByClientList", obj);
        if (res.status === 1) {
          this.page.totalResult = res.data.total;
          this.tableData = res.data.rows;
          this.tableData.map((i) => {
            this.records.map((j) => {
              if (i.id === j.id) {
                this.$refs.xTable.setCheckboxRow(i, true);
              }
            });
          });
          this.loading = false;
        } else {
          this.$XModal.alert({
            message: res.message ? res.message : "接口异常",
            status: "error",
          });
        }
      },
      getSearchListKey() {
        let obj = this.searchFormData;
        let paramsObj = {};
        Object.keys(obj).forEach((key) => {
          if (
            obj[key] !== null &&
            key !== "createTime" &&
            key !== "goodsBeginDate" &&
            key !== "secondPartyTime" &&
            obj[key] !== undefined
          ) {
            paramsObj[key] = obj[key];
          }
          if (obj["createTime"] && obj["createTime"].length > 0) {
            paramsObj.createTimeBegin = moment(obj.createTime[0]).valueOf(); // 开始时间
            paramsObj.createTimeEnd =
              moment(obj.createTime[1]).valueOf() + 86399999; // 结束时间
          }
          if (obj["goodsBeginDate"] && obj["goodsBeginDate"].length > 0) {
            paramsObj.goodsBeginDateBegin = moment(obj.goodsBeginDate[0]).valueOf(); // 开始时间
            paramsObj.goodsBeginDateEnd = moment(obj.goodsBeginDate[1]).valueOf() + 86399999; // 结束时间
          }
          if (obj["secondPartyTime"] && obj["secondPartyTime"].length > 0) {
            paramsObj.secondPartyTimeBegin = moment(obj.secondPartyTime[0]).valueOf(); // 开始时间
            paramsObj.secondPartyTimeEnd = moment(obj.secondPartyTime[1]).valueOf() + 86399999; // 结束时间
          }
        });
        paramsObj.page = 1;
        paramsObj.rows = this.page.pageSize;
        if (this.searchFirstPartyName.length > 0) {
          paramsObj.firstPartyNameList = this.searchFirstPartyName;
        }
        if (this.searchSecondPartyName.length > 0) {
          paramsObj.secondPartyNameList = this.searchSecondPartyName;
        }
        if (this.searchSalesMan.length > 0) {
          paramsObj.salesManList = this.searchSalesMan;
        }
        if (this.searchCreateUser.length > 0) {
          paramsObj.createUserList = this.searchCreateUser;
        }
        this.paramsObj = paramsObj;
        this.page.currentPage = 1;
        this.page.pageSize = 10;
        this.getContractFadadaByClientList(paramsObj);
        this.searchVisible = false;
      },
      changePage(e) {
        this.page.currentPage = e.currentPage;
        this.page.pageSize = e.pageSize;
        this.paramsObj.page = this.page.currentPage;
        this.paramsObj.rows = this.page.pageSize;
        this.getContractFadadaByClientList(this.paramsObj);
      },
    },
  };
</script>

<style scoped>


</style>
